/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductVariantResponse } from '../../models/product-variant-response';

export interface GetVariantsByPackagingUnitId$Params {

/**
 * Specified packagingUnitId
 */
  packagingUnitId: string;

/**
 * Zero-based page index (0..N)
 */
  page?: number;

/**
 * The size of the page to be returned
 */
  size?: number;

/**
 * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
 */
  sort?: Array<string>;
}

export function getVariantsByPackagingUnitId(http: HttpClient, rootUrl: string, params: GetVariantsByPackagingUnitId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProductVariantResponse>>> {
  const rb = new RequestBuilder(rootUrl, getVariantsByPackagingUnitId.PATH, 'get');
  if (params) {
    rb.path('packagingUnitId', params.packagingUnitId, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProductVariantResponse>>;
    })
  );
}

getVariantsByPackagingUnitId.PATH = '/search/products/{packagingUnitId}/variants';
